const FiltroPeriodoEnum = {
  ESTA_SEMANA: 'ESTA_SEMANA',
  ULTIMOS_SETE_DIAS: 'ULTIMOS_SETE_DIAS',
  ESTE_MES: 'ESTE_MES',
  ULTIMOS_TRINTA_DIAS: 'ULTIMOS_TRINTA_DIAS',
  MES_ANTERIOR: 'MES_ANTERIOR',
  PERSONALIZADO: 'PERSONALIZADO'
}

export default FiltroPeriodoEnum



// WEBPACK FOOTER //
// ./client/enum/filtroPeriodo.js